const initialState = {
  name: '',
  slug: '',
  description: '',
  fields: [],
  contentTypes: [],
  status: '',
  formId: '',
  previewUrl: ''
};

const contentReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'INITIATE_CONTENT_TYPE':
      return {
        ...state,
        status: action.payload.status,

      };
    case 'UPDATE_CONTENT_TYPE':
      return {
        ...state,
        name: action.payload.name,
        slug: action.payload.slug,
        description: action.payload.description,
        fields: action.payload.fields,
        previewUrl: action.payload.previewUrl
      };
    case 'ADD_FIELD':
      return {
        ...state,
        // fields: [...state.fields, action.payload],
        fields: Array.isArray(state.fields) ? [...state.fields, action.payload] : [action.payload],

      }
    case 'UPDATE_CONTENT_FIELD':
      const updatedFields = state.fields.map((field, idx) =>
        field['id'] === action.payload.index
          ? { ...field, ...action.payload.fieldData } : field
      );
      return { ...state, fields: updatedFields };

    case 'RESET_FORM':
      return initialState;
    case 'GET_CONTENT_TYPES':
      return {
        ...state,
        contentTypes: action.payload
      }
    case 'DELETE_CONTENT_TYPE':
      return {
        ...state,
        contentTypes: state.contentTypes.filter(contentTypes => contentTypes._id !== action.payload),
      }
    case 'GET_CONTENT':
      return {
        ...state,
        name: action.payload.name,
        slug: action.payload.slug,
        description: action.payload.description,
        fields: action.payload.fields,
        formId: action.payload._id,
        previewUrl: action.payload.previewUrl
      }
    case "REMOVE_FIELD":
      return {
        ...state,
        fields: state.fields.filter(fields => fields.id !== action.payload),
      };
    default:
      return state;
  }
};

export default contentReducer;
